import type { TrainingLessonSpecific } from './trainingLessonUi';

export const priest2PastoralEn: TrainingLessonSpecific = {
  intro:
    'A priest may perform baptisms by immersion when assigned, with the bishop’s authorization. Confirmation (bestowing the gift of the Holy Ghost) requires the Melchizedek Priesthood; a priest does not perform it for convert baptisms. In the temple, priests may participate in vicarious ordinances (baptisms and confirmations) for the deceased. His main roles are baptism, the sacrament, and missionary work. Good follow-up reduces discouragement; proper delegation protects reverence.',
  objectives: [
    'Understand the priest’s role in baptisms (may perform them under the bishop’s authorization).',
    'Understand that confirmation for new members requires the Melchizedek Priesthood.',
    'Learn to serve with respect and coordination.',
    'Strengthen new members and accompany those preparing for ordinances.',
    'Create a personal pastoral service plan.',
  ],
  briefHeading: 'Baptism, confirmation, and accompaniment',
  briefBody:
    'Always coordinate with those who hold keys. In living work, the priest baptizes when delegated; elders perform confirmation. In the temple you serve in vicarious ordinances. Pastoral accompaniment is part of priesthood service.',
  scriptures: [
    { ref: 'D&C 20:41–43', text: 'Baptism by immersion, in the name of the Father, Son, and Holy Ghost.' },
    { ref: 'Moroni 6:1–4', text: 'Baptism and confirmation: dignity and preparation.' },
    { ref: 'D&C 18:10–16', text: 'The worth of souls is great in the sight of God.' },
    { ref: 'Mosiah 18:8–10', text: 'Bear one another’s burdens… mourn with those that mourn…' },
    { ref: 'D&C 107:13–14', text: 'The Aaronic Priesthood holds the keys of the ministering of angels…' },
  ],
  didYouKnow: [
    'A priest may baptize under the bishop’s delegation; confirmation requires Melchizedek Priesthood.',
    'In the temple, priests participate in vicarious baptisms and confirmations for the deceased.',
    'All ordinances are done under the direction of those who hold keys (bishop or mission president).',
  ],
  practiceItems: [
    'Accompany a new member (or recent convert) to an activity or meeting',
    'Coordinate with a leader about helping with baptisms (or temple vicarious ordinances)',
    'Send an encouraging message to someone preparing for an ordinance',
    'Review baptism or sacrament protocol according to your assignment',
    'Observe and learn from a priest who serves with dignity',
    'Make a follow-up plan for one person recently baptized or confirmed',
  ],
  reflectionQuestions: [
    'Who can I accompany this week as they prepare for an ordinance?',
    'What is harder for me: coordinating with leaders or reaching out to new members?',
    'How will I protect reverence when participating in baptisms or temple ordinances?',
  ],
  actionText: 'Accompany one person preparing for an ordinance.',
};
